import React from "react";

import { makeStyles, createStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      marginTop: 18,
      marginBottom: 18,
      paddingBottom: 12,
      paddingRight: 12,
      paddingLeft: 12,
      background: theme.palette.primary.light,
    },
    readingListTitle: {
      paddingTop: 12,
      color: "white",
      background: theme.palette.primary.light,
    },
  })
);

export default function ProgressTrackerPlaceholder(props) {
  const classes = useStyles();

  return (
    <Paper elevation={3} className={classes.paper}>
      <Typography variant="h5" className={classes.readingListTitle}>
        Track Your Progress
      </Typography>

      <Typography component="div" key="subtitle1" variant="subtitle1">
        <Skeleton width={400} />
      </Typography>

      <Skeleton />
      <Skeleton />
      <Skeleton />

      <Skeleton width={150} height={70} />
    </Paper>
  );
}
